import type { Lender } from "@/lib/lenders";

export function LenderLogo({
  lender,
  size = 96,
  className = "",
  bare = false,
}: {
  lender: Lender;
  size?: number;
  className?: string;
  bare?: boolean;
}) {
  if (lender.logoUrl) {
    return (
      <div
        className={`grid shrink-0 place-items-center ${bare ? "" : "rounded-md bg-white"} ${className}`}
        style={{ width: size, height: size }}
      >
        <img
          src={lender.logoUrl}
          alt={`${lender.name} logotyp`}
          width={Math.round(size)}
          height={Math.round(size)}
          loading="lazy"
          decoding="async"
          className="max-h-full max-w-full object-contain"
          style={{ maxHeight: size * 0.98, maxWidth: size * 0.98 }}
        />
      </div>
    );
  }
  return (
    <div
      className={`grid shrink-0 place-items-center rounded-md bg-gradient-to-br ${lender.color} font-display font-black text-white shadow-sm ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.32 }}
      aria-label={`${lender.name} logotyp`}
    >
      {lender.initials}
    </div>
  );
}
